import { Component } from "@angular/core";

@Component({
  selector: "app-retailer-landing",
  templateUrl: "./retailer-landing.component.html",
  styleUrls: ["./retailer-landing.component.less"],
})
export class RetailerLandingComponent {}
